import { Dispatch } from 'react'
import { css } from '@emotion/react'
import { Dialog, DialogTitle, Typography } from '@mui/material'
import { ApprovalAction } from '../index'
import { ConfirmAcceptDialogContent } from './ConfirmAcceptDialogContent'
import { ConfirmCancelDialogContent } from './ConfirmCancelDialogContent'
import { ConfirmRejectDialogContent } from './ConfirmRejectDialogContent'
import { t } from '@lingui/core/macro'

const title = css`
  font-size: 20px;
`

interface Props {
  action: ApprovalAction | null
  open: boolean
  setOpen: Dispatch<boolean>
}

export const ConfirmDialog = ({ action, open, setOpen }: Props) => {
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog onClose={handleClose} open={open} data-test-atr="dialog-window">
      <DialogTitle>
        <Typography variant="h3" css={title}>
          {t`Are you sure?`}
        </Typography>
      </DialogTitle>
      {action === ApprovalAction.CANCEL && <ConfirmCancelDialogContent handleClose={handleClose} />}
      {action === ApprovalAction.REJECT && <ConfirmRejectDialogContent handleClose={handleClose} />}
      {action === ApprovalAction.ACCEPT && <ConfirmAcceptDialogContent handleClose={handleClose} />}
    </Dialog>
  )
}
